// extracted by mini-css-extract-plugin
module.exports = {"h3":"styles_h3__3UQxV","form_side":"styles_form_side__3orwo","label":"styles_label__2tO9G","mystyle":"styles_mystyle__tZlSF"};